<template>
    <v-container fluid>
        <v-card class="pa-4">
            <v-card-title class="text-h5 mb-4">
                Добавление колонки биллинга
            </v-card-title>

            <v-card-text>
                <v-form ref="form" v-model="valid">
                    <v-col cols="6 px-0">
                        <v-text-field v-model="name" label="Название колонки" :rules="nameRules" required maxlength="50"
                            counter outlined class="mb-4" type="text" />
                    </v-col>

                    <v-col cols="6 px-0">
                        <v-select v-model="selectedBillingKind" :items="billingKinds" item-text="name" item-value="id"
                            label="Тип колонки" :rules="billingKindRules" required outlined class="mb-4"
                            :loading="loadingKinds">
                            <template v-slot:no-data>
                                <v-list-item>
                                    <v-list-item-title>
                                        Нет доступных типов
                                    </v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-select>
                    </v-col>

                    <v-card-actions class="px-0">
                        <v-spacer />
                        <v-btn type="submit" class="px-8" color="primary" :loading="submitting"
                            @click.prevent="submitForm">
                            Добавить
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'AddBillingColumn',
    data() {
        return {
            name: '',
            selectedBillingKind: null,
            billingKinds: [],
            loadingKinds: false,
            valid: false,
            submitting: false,
            nameRules: [
                v => !!v || 'Название обязательно',
                v => (v && v.length <= 50) || 'Название должно содержать максимум 50 символов'
            ],
            billingKindRules: [
                v => !!v || 'Тип колонки обязателен'
            ]
        }
    },
    async created() {
        await this.loadBillingKinds();
    },
    methods: {
        async loadBillingKinds() {
            this.loadingKinds = true;
            try {
                const response = await this.axios.get('/billing/bill-column-vids');
                this.billingKinds = response.data;
            } catch (error) {
                console.error('Error loading billing kinds:', error);
                alert('Произошла ошибка при загрузке типов колонок');
            } finally {
                this.loadingKinds = false;
            }
        },
        async submitForm() {
            // Validate form
            if (!this.$refs.form.validate()) {
                return;
            }

            this.submitting = true;

            try {
                await this.axios.post('/billing/bill-columns', {
                    name: this.name,
                    vid: this.selectedBillingKind
                });

                // Redirect after successful submission
                this.$router.push('/settings/billingColumns');
            } catch (error) {
                console.error('Error:', error);
                alert('Произошла ошибка при сохранении');
            } finally {
                this.submitting = false;
            }
        }
    }
}
</script>